import React from 'react'
import Logout from '../features/auth/components/Logout'

const LogoutPage = () => {
  return (
    <div><Logout/></div>
  )
}

export default LogoutPage